import * as React from 'react'
import info from '../info.json'
import {Link} from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import { IconX, IconInfoSmall} from '@tabler/icons-react'
import { motion } from 'framer-motion'

export default function Form(props){


    const inputRef = React.useRef(null);

    const inputs = info.form.inputs.map((item)=>{

        return(
            <input 
                ref={inputRef}
                required
                type={item.type}
                className='w-full sm:w-[45%] xl:w-full bg-charcoal placeholder:text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-our' 
                placeholder={item.placeholder} 
                onTouchEnd={(e) => {
                    e.stopPropagation(); // Stop event propagation here
                    handleFocus();
              }}/>
        )
    })

    function Toggle(){
        props.setVisibleInfo((prevState)=>!prevState)
    }

        
    const variants = {
        moveX: {transform: ['translateX(-100%)', 'translateX(0%)'], opacity:['0', '100'], transition: { duration: 1, type: 'spring' }},
        stop: {transform: ['translateX(0%)', 'translateX(-100%)'], opacity:['100', '0'], transition: { duration: 2, type: 'spring' } }
        
    }

    const handleFocus = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };
  

    // React.useEffect(()=>{
    //     var infoBtn = document.getElementById('info-btn')
    //     var infoData = document.getElementById('info-data')
    //     function showInfo() {
    //         // infoData.style.display = 'block'
    //         // console.log('HOVERRR');
    //     }
    //     infoBtn.addEventListener('click', showInfo())
    // })

    return (
        <motion.div 
            variants={variants}
            animate={props.visibleInfo ? 'moveX' : 'stop'}
            className={`form-container info-container fixed pt-[10vh] md:pt-[90px] lg:absolute sm:bottom-0 left-0 h-full w-full max-w-[100vw] sm:max-w-[70vw] md:min-w-[500px] md:w-[30vw] xl:w-[25vw] bg-charcoal z-30 text-cream transition-opacity duration-100 opacity-0 overflow-y-auto`}>
        

                <div className='pt-[50px] px-[3vw]'>
                    <div className='self-center md:float-right -mr-2 mb-2 md:mb-4 cursor-pointer' onClick={Toggle} onTouchEnd={Toggle}>
                        <IconX size={40} stroke={1}/>
                    </div>
                    <StaticImage className='w-[80px] my-auto mt-20 mb-6' placeholder="color" aspectRatio={1} src='../images/logo-royal-big.png'/>

                    <div className='w-[100%] h-fit md:h-fit flex flex-col justify-start'>
                        <h1 className='uppercase mb-8 leading-[55px]'>
                            {props.moreAbout && props.moreAbout.moretitle}
                        </h1>

                    <div className='rich-content-page pb-16' dangerouslySetInnerHTML={{__html: props.moreAbout && props.moreAbout.moretext}}>

                    </div>
                    </div>
                </div>

        </motion.div>
    )
}
